import { ShippingPackages } from './shipping-packages.model';
import { WeightUnits } from './weight-units.model';
import { ShipFrom } from './ship-from.model';
import { ShipTo } from './ship-to.model';

export class ProcessShipmentRequest {
    CarrierServiceCode: string;
    OrderCode: string;
    PurchaseOrderNumber: string[];
    RequireDryIceShipment: boolean;
    DryIceWeight: number;
    ReturnShipment: boolean;
    NotificationRequired: boolean;
    NotificationLanguageCode: string[];
    UseCustomsClearanceBroker: boolean;
    PermitInformation: string[];
    BillingCurrencyCode: string;
    ShipFrom: ShipFrom;
    ShipTo: ShipTo;
    ShippingPackage: ShippingPackages[];
    DryIceWeightUnit: WeightUnits;
}
